/* src/app/my-nav/my-nav.component.css */
.sidenav-container {
  height: 100%;
}
.sidenav {
  width: 200px;
}
.sidenav .mat-toolbar {
  background: inherit;
}
.mat-toolbar.mat-primary {
  position: sticky;
  top: 0;
  z-index: 1;
}
/*# sourceMappingURL=my-nav.component.css.map */
